import React from 'react'
import CustomToastUi from './CustomToastUi'

const CustomToast = ({text,type}) => {
  return (
    <CustomToastUi text={text} type={type}/>
  )
}

export default CustomToast